import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { isArray } from 'lodash';
import { Form, Accordion, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Button from '../ui/Button';
import Loader from '../ui/Loader';
import { allowDropHandler, showMetaEditTool } from '../../utils/uiUtils';
import { SearchParams } from '../../utils/searchUtils';
import { clearMetadata, metaAttach } from '../../actions/metaAttach';
import { stringifiedToDraggable } from '../../utils/draggables';
import {
  META_ATTACH_STATE_NONE,
  META_ATTACH_STATE_IN_PROGRESS,
} from '../../constants/metaAttachStates';
import { deselectAll } from '../../actions/umoGallery';

class MetaAttach extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReplace: false,
    };

    this.attachMetadata = this.attachMetadata.bind(this);
    this.dropHandler = this.dropHandler.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onAttachSelectedClick = this.onAttachSelectedClick.bind(this);
    this.onReplaceCheck = this.onReplaceCheck.bind(this);
    this.editMetadata = this.editMetadata.bind(this);
    this.parseMetatag = this.parseMetatag.bind(this);
  }

  onAttachSelectedClick() {
    this.attachMetadata(this.props.selectedUMOIDs.toJS(),
      this.props.isSelectAll ? this.props.searchParams : null);
  }

  onCancelClick() {
    this.props.dispatch(clearMetadata());
  }

  onReplaceCheck() {
    this.setState({ isReplace: !this.state.isReplace });
  }

  attachMetadata(umoIDList, searchParams) {
    this.props.dispatch(metaAttach(
      this.props.metaAttachState.get('metadataToAttach').toJS(),
      umoIDList,
      this.state.isReplace,
      searchParams,
      this.props.intl
    ))
      .then(() => this.props.dispatch(deselectAll()));
  }

  dropHandler(e) {
    e.preventDefault();
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    if (!(draggable instanceof Error)) {
      this.attachMetadata(
        isArray(draggable.getSelectionList()) ?
          draggable.getSelectionList() : [],
        draggable.getIsSelectAll() ? draggable.getSearchParams() : null
      );
    }
  }

  editMetadata() {
    const metaPatams = JSON.stringify(this.props.metaAttachState.get('metadataToAttach').toJS());
    sessionStorage.setItem('massMetaEditVals', metaPatams);
    showMetaEditTool(null, this.props.dispatch);
  }

  getMetatagVal(value) {
    if(_.isArray(value)) {
      if (_.isArray(value[0])) { // repeating group
        const dispValue = [];
        value.forEach((repMeta) => dispValue.push(this.parseMetatag(repMeta)))
        return <ul className="meta-attach__cur-inner-list">{dispValue}</ul>;
      } else { // repeating field
        return <ul className="meta-attach__cur-inner-list">{value.map(v => <li key={v}>{v}</li>)}</ul>;
      }
    } else return value
  }

  parseMetatag(tags) {
    const metas = [];
    tags.forEach((meta) =>
      metas.push(<li key={`mt-edt-${meta.id}`}>{meta.label} - {this.getMetatagVal(meta.value)}</li>));
    return metas;
  }

  render() {
    const isLoading = this.props.metaAttachState.get('state') === META_ATTACH_STATE_IN_PROGRESS;
    let isDisabled = false;
    const metatags = this.parseMetatag(this.props.metaAttachState.get('metadataToAttach').toJS());
    const editMetaTT =
      <Tooltip id="meta-attach__edit-values-tooltip">
        {this.props.intl.formatMessage({ id: 'metaAttach.editCurValues' })}
      </Tooltip>;

    if (isLoading ||
      (this.props.isSelectAll && !this.props.searchParams) ||
      (!this.props.isSelectAll && this.props.selectedUMOIDs.count() < 1)) {
      isDisabled = true;
    }

    return (
    this.props.metaAttachState.get('state') !== META_ATTACH_STATE_NONE ?
      <div className="meta-attach">
        <div className="meta-attach__controls-container">
          <Button
            primary
            block
            disabled={isDisabled}
            onClick={this.onAttachSelectedClick}
          >
            { isLoading ? <Loader /> : this.props.intl.formatMessage({ id: 'metaAttach.attachButton' }) }
          </Button>
          <Form.Group className="meta-attach__controls-container__replace-check">
            <Form.Check
              type='checkbox'
              id="meta-attach__replace-check"
              onChange={this.onReplaceCheck}
              checked={this.state.isReplace}
              label={this.props.intl.formatMessage({ id: 'metaAttach.replaceCheckbox' })}
            />
            <Form.Text className="text-muted">{this.props.intl.formatMessage({ id: 'metaAttach.defaultAttachBehavior' })}</ Form.Text>
          </Form.Group>
          <Accordion>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0" className="meta-attach__cur">
                  <div>
                    <i className="fas fa-chevron-down meta-attach__cur-values"/>
                    {this.props.intl.formatMessage({ id: 'metaAttach.currentValues' })}
                  </div>
                </Accordion.Toggle>
                <OverlayTrigger overlay={editMetaTT} placement="bottom">
                  <Button variant="link" onClick={this.editMetadata}><i className="fas fa-pencil-alt meta-attach__edit-values"/></Button>
                </OverlayTrigger>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body><ul className="meta-attach__cur-list">{metatags}</ul></Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
        { // don't display the drop area on IE browsers
          navigator.msSaveBlob ? null :
            <div className="meta-attach__drop-container">
              <div
                className="meta-attach__drop-area"
                onDrop={this.dropHandler}
                onDragOver={isLoading ? undefined : allowDropHandler}
              >
                <div><i className="meta-attach__drop-icon" /></div>
                <p>{this.props.intl.formatMessage({ id: 'metaAttach.attachArea' })}</p>
              </div>
            </div>
        }
        <p>
          <button className="meta-attach__close-button" onClick={this.onCancelClick} />
        </p>
      </div>
      : null
    );
  }
}

MetaAttach.propTypes = {
  metaAttachState: PropTypes.instanceOf(Map),
  dispatch: PropTypes.func,
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  isSelectAll: PropTypes.bool,
};

export default injectIntl(MetaAttach);



// WEBPACK FOOTER //
// ./src/js/components/MetaAttach/index.jsx